export default {
  freeTimesLimitTitle: 'मुफ्त खाते के लिए परीक्षण आज बाहर चला गया है।',
  fileSizeLimitTitle:
    'मुफ्त खाते के लिए फ़ाइल का आकार 20MB से अधिक नहीं हो सकता है।',
  total: 'कुल',
  enterCode: 'कोड डालें',
  signUpToPurchaseBtn: 'ख़रीदने के लिए साइन अप करें',
  goPurchseBtn: 'ख़रीदारी पर जाएं',
  saveTips: '{{num}}% तक बचाएं',
  discount: 'छूट',
  montly: 'मासिक',
  yearly: 'वार्षिक',
  weekly: 'साप्ताहिक',
  week: 'सप्ताह',
  priceWeek: '$9.99',
  priceMonth: '$7.49',
  priceYearly: '$3.75',
  billMonth: '$29.99 मासिक बिल',
  billYear: '$179.99 वार्षिक बिल',
  AlreadySubscribe: 'पहले से सदस्यता ले रखी?',
  vipTips1: 'कोई फ़ाइल आकार सीमा नहीं',
  vipTips2: 'सीमा के बिना फ़ाइल मात्रा की प्रक्रिया',
  vipTips3: 'सीमा के बिना छवि पृष्ठभूमि बदलें',
  vipTips4: 'सभी मुफ्त उपकरण और प्रीमियम सुविधाओं तक पहुंच',
  purchaseTips: 'स्वचालित रूप से नवीनीकृत करें और किसी भी समय रद्द करें।',
  tips: 'उपाय:',
  promoCodeInvalidTips: 'आपका प्रोमो कोड अमान्य है',
};
